import items from "../../web-sh/src/components/items";
import UserInfo from "./UserInfo";
import CloudImageIcon from "./CloudImageIcon";
import CreditCard from "./CreditCard";

const itemsComponents = {
  ...items,
  UserInfo,
  CloudImageIcon,
  CreditCard
}
export default itemsComponents